(function ($) {
	'use strict';
	
	$.fn.showPassword = function (options) {

		const init = function($self) {
			const classActive = 'is_active';
			const $container = $self.closest( '.show-password-container' );
			const $inputPassword = $container.find( '[type="password"]' );
			const label = {
				showPassword: $self.attr('aria-label'),
				hidePassword: lang === 'fr' ? 'Cacher le mot de passe' : 'Hide password'
			}

			$self.on('click.showPassword', function(){
				const isActive = $self.hasClass( classActive );

				if( isActive ) {
					$inputPassword.attr('type', 'password');
					$self.removeClass( classActive ).attr('aria-label', label.showPassword);
				} else {
					$inputPassword.attr('type', 'text');
					$self.addClass( classActive ).attr('aria-label', label.hidePassword);
				}
			});
		}

		return this.each(function () {
			init($(this));
		});
	}
})(jQuery);